require('../../modules/es6.object.assign');
module.exports = require('../../modules/_core').Object.assign;



//////////////////
// WEBPACK FOOTER
// ./~/redux-act-async/~/core-js/library/fn/object/assign.js
// module id = 2105
// module chunks = 0